import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";

// If a JS/CSS chunk fails to load (usually because a new build shipped and the
// old hashed file is gone), reload the page once so the client fetches the
// fresh index.html + chunks. Guarded by sessionStorage to avoid reload loops.
const CHUNK_RELOAD_KEY = "__chunk_reload_attempted__";

const looksLikeChunkFailure = (target, message) => {
  if (target && (target.tagName === "SCRIPT" || target.tagName === "LINK")) {
    const src = target.src || target.href || "";
    if (src.includes("/static/js/") || src.includes("/static/css/")) return true;
  }
  if (typeof message === "string" && /ChunkLoadError|Loading chunk .* failed|Loading CSS chunk/.test(message)) {
    return true;
  }
  return false;
};

const tryReloadOnce = () => {
  if (typeof window === "undefined") return;
  try {
    if (window.sessionStorage.getItem(CHUNK_RELOAD_KEY)) return;
    window.sessionStorage.setItem(CHUNK_RELOAD_KEY, "1");
  } catch (_e) {
    // sessionStorage unavailable — reload once anyway.
  }
  window.location.reload();
};

window.addEventListener(
  "error",
  (event) => {
    if (looksLikeChunkFailure(event.target, event.message)) tryReloadOnce();
  },
  true // capture: resource load errors don't bubble
);

window.addEventListener("unhandledrejection", (event) => {
  const reason = event.reason;
  const message = (reason && (reason.message || reason.toString())) || "";
  if (looksLikeChunkFailure(null, message)) tryReloadOnce();
});

// Clear the guard after a successful load so future chunk failures can retry.
window.addEventListener("load", () => {
  try {
    window.sessionStorage.removeItem(CHUNK_RELOAD_KEY);
  } catch (_e) { /* noop */ }
});

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
